import { useSession } from "@/lib/auth";
import { tokenScope } from "@/lib/session-scope";
import { useWorkspaces } from "@/lib/workspace";
import { isWorkspaceAdminRole } from "./validation";

export function useUgcAdminScope(): { userId: string; tenantId: string } | null {
  const session = useSession();
  if (!session?.user.id) return null;
  return {
    userId: session.user.id,
    tenantId: session.tenantId || tokenScope(session.token)?.tenantId || "",
  };
}

/** Role is `known` after the workspace list has loaded, even if the current workspace is gone. */
export function useCurrentUgcWorkspaceRole(): { role: string | undefined; known: boolean } {
  const session = useSession();
  const workspaces = useWorkspaces();
  if (!session || !workspaces.data) return { role: undefined, known: false };
  const current = session.tenantId
    ? workspaces.data.find(
        (workspace) => workspace.id === session.tenantId || workspace.tenant_id === session.tenantId,
      )
    : workspaces.data[0];
  return { role: current?.role, known: true };
}

export function useCanManageUgc(): boolean {
  const { role, known } = useCurrentUgcWorkspaceRole();
  return known && isWorkspaceAdminRole(role);
}
